import { debug } from "util";

cb.define([], function () {
  var AA_bill_userdefbtn_VM_Extend = {

    doAction: function (name, viewmodel) {
      if (this[name]) {
        this[name](viewmodel);
      }
    },

    disableSysBtn: function (viewmodel) {
      let actions = viewmodel.get('actions');
      actions.getData().forEach((element, rowIndex) => {
        if (element.isSystem) {
          actions.setRowState(rowIndex, "disabled", true)
        }
      });
    },
    init: function (viewmodel) {
      var self = this;
      viewmodel.get('btnEdit').on('click', function () {
        //  alert(1111);
        self.disableSysBtn(viewmodel);

      });
      var mode = viewmodel.getParams().mode;
      if (mode == 'edit') {
        viewmodel.on('afterLoadData', function (data) {
          self.disableSysBtn(viewmodel);
        });
      };
      var gridModel = viewmodel.get('actions');
      if (gridModel) {
        gridModel.on('beforeCellValueChange', function (data) {
          var length = gridModel.getRows().length;
          if (data.cellName == 'tblItemName') {  //按钮名称
            for (var i = 0; i < length; i++) {
              if (i != data.rowIndex) {
                if (data.value == gridModel.getCellValue(i, 'tblItemName')) {
                  cb.utils.alert("按钮名称不唯一，请检查后重试！");
                  return false;
                }
              }
            }
          }
        });
      }
    }
  }
  try {
    module.exports = AA_bill_userdefbtn_VM_Extend;
  } catch (error) {

  }
  return AA_bill_userdefbtn_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/AA/AA_bill_userdefbtn_VM.Extend.js